<template>
  <div v-if="repairDetil" class="repair-detail bg-page h-screen overflow-y-scroll">
    <div class="bg-theme text-white text-16 h-50 flex items-center pl-15">
      工单状态：{{ repairDetil.repairstate == 4 ? "审核中" : repairDetil.repairstate_name }}
    </div>
    <DetailBlockItem title="工单内容" class="bg-white mb-8">
      <div class="p-15 border-t">
        <DetailItem label="报单项目：" :value="shop_name" />
        <DetailItem label="工单编号：" :value="repairDetil.orderid" />
        <DetailItem
          v-if="repairDetil.event_detail && repairDetil.event_detail.id"
          label="关联事务："
          :is-blue="true"
          :value="repairDetil.event_detail.event_code"
          @click="toEventDetail(repairDetil.event_detail.id)"
        />
        <DetailItem label="报单时间：" :value="repairDetil.fault_time_name" />
        <DetailItem label="工单类型：" :value="repairDetil.faulttype_name" />
        <DetailItem v-if="repairDetil.store_detail" label="关联客户：" :value="repairDetil.store_detail.stores_name" />
        <DetailItem label="报单位置：" :value="repairDetil.place_name" />
        <DetailItem label="报单内容：" :value="repairDetil.cause" />
        <DetailItem
          v-if="repairDetil.fault_pic.length"
          label="报单图片："
          type="img"
          flex="col"
          :value="repairDetil.fault_pic"
        />
        <DetailItem
          v-if="repairDetil.appointment_time_name"
          label="预约时间："
          :value="repairDetil.appointment_time_name"
        />
        <DetailItem v-if="repairDetil.replace_json && repairDetil.replace_json.length" label="代报单：" flex="col">
          <div style="border:1px dashed #ccd3df" class="p-15 mt-10">
            <div v-for="(item, index) in repairDetil.replace_json" :key="index">
              <DetailItem :label="`${item.name}：`" :value="item.content" />
            </div>
          </div>
        </DetailItem>
      </div>
    </DetailBlockItem>

    <DetailBlockItem
      v-if="[2, 3, 4, 5, 6, 7, 8].includes(Number(repairDetil.repairstate))"
      title="处理人信息"
      class="bg-white mb-8"
    >
      <div class="p-15 border-t">
        <DetailItem label="处理人：" :value="repairDetil.repair_user_arr[0].name" />
        <DetailItem label="联系电话：" type="tel" :value="repairDetil.repair_user_arr[0].phone" />
        <template v-if="![1, 2, 3].includes(Number(repairDetil.repairstate)) || repairDetil.pause_state != 1">
          <DetailItem label="处理时间：" :value="repairDetil.last_log.create_date" />
          <DetailItem label="处理结果：" :value="repairDetil.report.real_repairstate_name" />
          <DetailItem
            v-if="repairDetil.report.real_repairstate_name != '已解决'"
            label="未解决原因："
            :value="repairDetil.collection_name"
          />
          <DetailItem label="处理记录：" :value="repairDetil.workprocess" />
          <DetailItem
            label="处理图片："
            type="img"
            :flex="repairDetil.fixed_pic.length ? 'col' : '-'"
            :value="repairDetil.fixed_pic.length ? repairDetil.fixed_pic : '-'"
          />
          <DetailItem
            label="签名："
            type="img"
            :cols="1"
            style="margin-bottom: 0;"
            :flex="repairDetil.scene_sign_pic.length ? 'col' : '-'"
            :value="repairDetil.scene_sign_pic.length ? repairDetil.scene_sign_pic : '-'"
          />

          <DetailItem label="使用物料：" :flex="repairDetil.parts_num > 0 ? 'col' : ''">
            <template v-if="repairDetil.parts_num > 0">
              <div class="border-all mt-10">
                <div class="flex">
                  <span class="flex-1 text-label leading-30 border-r text-center">物料名称</span>
                  <span class="flex-1 text-label leading-30 border-r text-center">数量</span>
                  <span class="flex-1 text-label leading-30 text-center">单价(元)</span>
                </div>
                <div v-for="(item, idx) in partsList" :key="idx" class="flex">
                  <span class="flex-1 text-default leading-24 border-t border-r p-8 text-center ">{{ item.name }}</span>
                  <span class="flex-1 text-default leading-24 border-t border-r p-8 text-center">{{ item.num }}</span>
                  <span class="flex-1 text-default leading-24 border-t p-8 text-center">{{ item.sale_price }}</span>
                </div>
              </div>
            </template>
            <div v-else>未使用</div>
          </DetailItem>

          <DetailItem label="工时：" :value="repairDetil.man_hours_str" />
        </template>

        <DetailItem
          v-if="![1, 2].includes(Number(repairDetil.repairstate)) || repairDetil.pause_state != 1"
          label="工单费用："
          :value="repairDetil.man_hours_str"
        >
          <div v-if="repairDetil.is_sale == 1">
            物料费:{{ repairDetil.parts_sale_money || 0 }}元,工时费:{{ repairDetil.manhour_money || 0 }}元,总计:{{
              repairDetil.totalCost
            }}元
          </div>
          <div v-else>-</div>
        </DetailItem>

        <DetailItem
          v-if="![1, 2, 3].includes(Number(repairDetil.repairstate)) || repairDetil.pause_state != 1"
          label="备注："
          :value="repairDetil.sale_desc"
        />
      </div>
    </DetailBlockItem>

    <DetailBlockItem v-if="repairDetil.repairstate == 6" title="评价信息" class="bg-white mb-8">
      <div class="p-15 border-t">
        <DetailItem label="评价时间：" :value="repairDetil.evaluation_time_name" />
        <DetailItem label="报单内容：" :value="repairDetil.evaluation_notes" />
        <DetailItem
          v-if="repairDetil.evaluation_pic.length"
          type="img"
          flex="col"
          :value="repairDetil.evaluation_pic"
        />
        <DetailItem label="响应速度：">
          <div>
            <van-rate :modelValue="Number(repairDetil.praise.speed)" :size="25" color="#FFB62F" readonly />
          </div>
        </DetailItem>
        <DetailItem label="服务态度：">
          <div>
            <van-rate :modelValue="Number(repairDetil.praise.serve)" :size="25" color="#FFB62F" readonly />
          </div>
        </DetailItem>
        <DetailItem label="服务质量：">
          <div>
            <van-rate :modelValue="Number(repairDetil.praise.professional)" :size="25" color="#FFB62F" readonly />
          </div>
        </DetailItem>
      </div>
    </DetailBlockItem>

    <DetailBlockItem v-if="repairDetil.close_state == 2" title="取消原因" class="bg-white mb-8">
      <div class="text-default text-16 p-15 border-t">
        {{ repairDetil.close_info.close_content ? repairDetil.close_info.close_content : "无" }}
      </div>
    </DetailBlockItem>

    <div :class="['bg-grey', buttonList.length ? 'h-100' : 'h-20']"></div>

    <FooterButton
      v-if="buttonList.length === 2"
      :cancelText="buttonList[0].button_name"
      :okText="buttonList[1].button_name"
      @cancel="handleButton(buttonList[0].button_key)"
      @submit="handleButton(buttonList[1].button_key)"
    />
    <FooterButton
      v-else-if="buttonList.length === 1"
      :showCancel="false"
      :okText="buttonList[0].button_name"
      @submit="handleButton(buttonList[0].button_key)"
    />
    <FooterButton
      v-else-if="buttonList.length >= 3"
      type="three"
      :cancelText="buttonList[0].button_name"
      :okText="buttonList[1].button_name"
      :menuList="menuList"
      @cancel="handleButton(buttonList[0].button_key)"
      @submit="handleButton(buttonList[1].button_key)"
      @menu="handleButton"
    />

    <AppraiseOrder v-model:show="appraiseOrderVisible" @refresh="initPage()" />

    <CancelOrder v-model="cancelOrderVisible" @refresh="initPage()" />

    <RejectOrder v-model="rejectOrderVisible" @refresh="initPage()" />

    <RefuseOrder v-model="refuseOrderVisible" @refresh="initPage()" />

    <UfSignature v-model:show="signVisible" @confirm="confirmCompletion" />
  </div>
</template>

<script setup>
import to from "await-to-js";
import { ref, computed } from "vue";
import { repairService, depotService } from "@/service";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import { DetailBlockItem, DetailItem } from "@/components/DetailView/index";
import { FooterButton } from "@/components/FormView/index";
import AppraiseOrder from "./components/detail/AppraiseOrder.vue";
import CancelOrder from "./components/detail/CancelOrder.vue";
import RejectOrder from "./components/detail/RejectOrder.vue";
import RefuseOrder from "./components/detail/RefuseOrder.vue";

const route = useRoute();
const router = useRouter();

const store = useStore();
const shop_name = computed(() => store.state.userInfo.shop_name);

// 确认完成回调
const confirmCompletion = async val => {
  const [error] = await to(
    repairService.faultConfirm({
      workorder_id: route.query.id,
      confirm_state: "1",
      user_sign_pic: val ? val.id : ""
    })
  );
  if (error) return;

  initPage();
};

//  同意挂单
const argeeOrder = async () => {
  const [error] = await to(repairService.workorderPauseVerify({ workorder_id: route.query.id, result: "1" }));
  if (error) return;
  initPage();
};

const toEventDetail = id => {
  router.push({ name: "eventsDetail", params: { id } });
};

// 评价工单
const appraiseOrderVisible = ref(false);
// 取消工单
const cancelOrderVisible = ref(false);
// 驳回工单
const rejectOrderVisible = ref(false);
// 确认完成,是否需要签名
const signVisible = ref(false);
// 拒绝挂单
const refuseOrderVisible = ref(false);

const handleButton = key => {
  switch (String(key)) {
    case "1":
      cancelOrderVisible.value = true;
      break;
    case "7":
      rejectOrderVisible.value = true;
      break;
    case "8":
      if (repairDetil.value.charge_workorder_need_sign === "0") {
        signVisible.value = true;
      } else {
        confirmCompletion();
      }
      break;
    case "9":
      appraiseOrderVisible.value = true;
      break;
    case "11":
      refuseOrderVisible.value = true;
      break;
    case "12":
      argeeOrder();
      break;
    default:
      break;
  }
};

const buttonList = ref([]);
const menuList = computed(() => {
  if (buttonList.value.length <= 2) return [];
  return buttonList.value.map(item => ({ text: item.button_name, label: item.button_key })).splice(2);
});

const getButton = async () => {
  buttonList.value = [];
  const [error, data] = await to(repairService.handle_button({ workorder_id: route.query.id }));
  if (error || !data.data.data) return;

  const arr = ["1", "7", "8", "9", "11", "12"];
  data.data.data.forEach(i => {
    if (arr.includes(String(i.button_key))) buttonList.value.push(i);
  });
};

const repairDetil = ref(null);
const getDetail = async () => {
  const [error, data] = await to(repairService.repair_con({ id: route.query.id, is_picking: 1 }));
  if (error) return;
  const { manhour_money, parts_sale_money, parts_num } = data.data.data;
  repairDetil.value = {
    ...data.data.data,
    parts_num: Number(parts_num),
    manhour_money: parseFloat(manhour_money),
    parts_sale_money: parseFloat(parts_sale_money),
    totalCost: parseFloat(manhour_money) + parseFloat(parts_sale_money)
  };

  if (repairDetil.value.parts_num > 0) getParts();
};

const partsList = ref([]);
const getParts = async () => {
  const [error, data] = await to(
    depotService.reduction_order_parts_together({ item_type: "1", item_id: route.query.id })
  );
  if (error) return;
  partsList.value = data.data.data.order_parts;
};

const initPage = () => {
  getDetail();
  getButton();
};

initPage();
</script>
